import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { merge } from 'site-modules/shared/components/lead-form/utils/merge';
import {
  HEADER_COMPONENT,
  LEAD_FORM_VIEWS,
  LEAD_TYPES,
  SUB_HEADER_COMPONENT,
} from 'site-modules/shared/constants/lead-form/lead-form-params';
import { getPathname, getLeadSubmissionInfoWithoutEmail } from 'site-modules/shared/components/lead-form/utils/utils';
import { sendUsedInventoryMarketoThankYouEmail } from 'site-modules/shared/components/lead-form/lead-form-wrapper/lead-form-wrapper-methods';
import { getLeadFormCreativeId } from 'client/site-modules/shared/components/lead-form/utils/lead-form-creative-id';
import { getCarZingTags } from 'site-modules/shared/components/inventory/utils/carzing';
import { UnifiedLeadFormAsync } from 'site-modules/shared/components/lead-form/unified-lead-form/unified-lead-form-async';

export function UciLeadForm({ params, options }) {
  const {
    vin,
    make,
    model,
    year,
    submodel,
    submodelIdentifier,
    zipCode,
    radius,
    pageNameLegacy,
    isNewVin,
    formName,
    partnerCode,
    type,
  } = params;
  const { toggleDrawer, tcpaParentDealershipName } = options;

  const customConfig = {
    leadType: LEAD_TYPES.INVENTORY,
    creativeId: getLeadFormCreativeId({
      isNewVin,
      pageNameLegacy,
      formName,
    }),
    leadFormComponent: LEAD_FORM_VIEWS.SIMPLE_INVENTORY_VIEW,
    leadFormConfig: {
      submitButtonText: 'Request Information',
      headerConfig: {
        headerComponent: HEADER_COMPONENT.CONVEX,
      },
      tcpaParentDealershipName,
      title: 'Request Information',
      subtitle: `A ${get(params, 'dealerName')} agent will answer your questions.`,
      withFormClasses: false,
      toggleDrawer,
      type,
    },
    processDataMethods: {
      postProcessMethods: [sendUsedInventoryMarketoThankYouEmail],
      getLeadSubmissionInfo: getLeadSubmissionInfoWithoutEmail,
    },
    thankYouConfig: {
      headerConfig: {
        subHeaderComponent: SUB_HEADER_COMPONENT.BASE,
        subHeader: {
          text: 'You’re All Set',
          explainingText: 'Your request has been sent and the dealer should follow up shortly.',
          insiderLinkOut: true,
        },
      },
    },
    tags: getCarZingTags(partnerCode),
  };

  const optionsConfig = get(options, 'customConfig', {});
  const formProps = {
    vin,
    make,
    model,
    year,
    submodel,
    submodelIdentifier,
    zipCode,
    radius,
    pathname: getPathname(options),
    customConfig: merge(customConfig, optionsConfig),
  };

  return <UnifiedLeadFormAsync {...formProps} />;
}

UciLeadForm.propTypes = {
  params: PropTypes.shape({
    vin: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.number,
    submodel: PropTypes.string,
    submodelIdentifier: PropTypes.string,
    zipCode: PropTypes.string,
    radius: PropTypes.number,
    pageNameLegacy: PropTypes.string,
    isNewVin: PropTypes.bool,
    formName: PropTypes.string,
    partnerCode: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  options: PropTypes.shape({
    toggleDrawer: PropTypes.func,
    tcpaParentDealershipName: PropTypes.string,
  }).isRequired,
};
